(function() {
    'use strict';

    angular.module('anrescowebApp').factory('BillingAccess', BillingAccess);

    BillingAccess.$inject = ['$http', '$q', '$state'];

    function BillingAccess($http, $q, $state) {
        return {
            requireAccess: function() {
                return $http.get('api/customer/billing-access').then(function(response) {
                    if (response.data.allowed === true) {
                        return true;
                    }
                    $state.go('home');
                    return $q.reject({status: 403, message: 'Billing is not available for this account.'});
                });
            }
        };
    }
})();
